import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";
import TableBase from "./TableBase.vue";
import { $get } from "@/plugins/api/api";
import { Paths } from "@/plugins/api/paths";
import { CheckApprovalShift } from "@/models/approval/ApprovalResponse";
import ShiftExpandItem from "../expand/ShiftExpandItem.vue";

type Props = {
  shiftId: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'ShiftDialogTable',
  props: {
    shiftId: null
  },
  setup(__props: any) {

const props = __props as {
  shiftId: string;
};



const items = ref<CheckApprovalShift[]>([]);

const getItems = async () => {
  const response = await $get<CheckApprovalShift[]>(
    `${Paths.approval.shiftTable.shift}/${props.shiftId}`
  );
  if (response) items.value = response;
};

watch(
  () => props.shiftId,
  async () => {
    await getItems();
  },
  { immediate: true }
);

return { __sfc: true,props, items, getItems, TableBase, ShiftExpandItem }
}

})